"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingModule2x1ImageLeft = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Container = require("../../components/Container/Container");

var _Column = require("../../components/Column/Column");

var _Row = require("../../components/Row/Row");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = require("../../components/Box/Box");

var _LazyPicture = require("../../components/LazyPicture/LazyPicture");

var _Theme = require("../../Theme/Theme.variables");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    text-align: right;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledColumn = (0, _styledComponents.default)(_Column.Column)(_templateObject(), function (props) {
  return (0, _Theme.variables)(props).breakpoints['xs'];
});

var MarketingModule2x1ImageLeft = function MarketingModule2x1ImageLeft(_ref) {
  var alignItems = _ref.alignItems,
      mainContent = _ref.mainContent,
      block1 = _ref.block1,
      imageUrl = _ref.imageUrl,
      imageAspectRatio = _ref.imageAspectRatio,
      imageFocalPointY = _ref.imageFocalPointY,
      imageAlt = _ref.imageAlt,
      polaroid = _ref.polaroid,
      spaceDefaultEnabled = _ref.spaceDefaultEnabled,
      props = _objectWithoutProperties(_ref, ["alignItems", "mainContent", "block1", "imageUrl", "imageAspectRatio", "imageFocalPointY", "imageAlt", "polaroid", "spaceDefaultEnabled"]);

  return _react.default.createElement(_Container.Container, _extends({
    my: spaceDefaultEnabled ? [5, 5, 5, 6, 6, 6] : []
  }, props), _react.default.createElement(_Row.Row, {
    flexWrap: true,
    alignItems: alignItems
  }, _react.default.createElement(_Column.Column, {
    column: 0,
    columnXs: 0,
    columnSm: 0,
    columnMd: 0,
    columnLg: 1
  }), _react.default.createElement(StyledColumn, {
    column: 10,
    columnXs: 6,
    columnSm: 6,
    columnMd: 5,
    columnLg: 4,
    mb: [4, 0, 0, 0, 0, 0]
  }, imageUrl && _react.default.createElement(_Box.Box, {
    polaroid: polaroid,
    shadowLevel: polaroid ? 3 : 0
  }, _react.default.createElement(_LazyPicture.LazyPicture, {
    className: "lozad",
    "data-iesrc": "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=340"),
    "data-alt": imageAlt
  }, _react.default.createElement("source", {
    media: "(min-width: ".concat(_Theme.breakpoints['lg'], ")"),
    srcSet: "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=376")
  }), _react.default.createElement("source", {
    media: "(min-width: ".concat(_Theme.breakpoints['md'], ")"),
    srcSet: "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=358")
  }), _react.default.createElement("source", {
    media: "(min-width: ".concat(_Theme.breakpoints['sm'], ")"),
    srcSet: "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=322")
  }), _react.default.createElement("source", {
    media: "(min-width: ".concat(_Theme.breakpoints['xs'], ")"),
    srcSet: "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=254")
  }), _react.default.createElement("source", {
    srcSet: "".concat(imageUrl, "?fm=jpg&fit=crop&ar=7:5&crop=fp&fp-y=").concat(imageFocalPointY, "&w=340")
  }), _react.default.createElement("noscript", null, _react.default.createElement("img", {
    src: "".concat(imageUrl, "?fm=jpg&fit=crop").concat(!!imageAspectRatio ? '&ar=' + imageAspectRatio : '', "&w=340"),
    alt: imageAlt
  })))), block1 && !imageUrl && block1), _react.default.createElement(_Column.Column, {
    column: 2,
    columnXs: 0
  }), _react.default.createElement(_Column.Column, {
    column: 2,
    columnXs: 1,
    columnSm: 1,
    columnMd: 1,
    columnLg: 1
  }), _react.default.createElement(_Column.Column, {
    column: 10,
    columnXs: 5,
    columnSm: 5,
    columnMd: 4,
    columnLg: 4
  }, mainContent && mainContent)));
};

exports.MarketingModule2x1ImageLeft = MarketingModule2x1ImageLeft;
MarketingModule2x1ImageLeft.propTypes = {
  alignItems: _propTypes.default.string,
  mainContent: _propTypes.default.object,
  block1: _propTypes.default.object,
  imageUrl: _propTypes.default.string,
  imageAspectRatio: _propTypes.default.string,
  imageFocalPointY: _propTypes.default.number,
  imageAlt: _propTypes.default.string,
  polaroid: _propTypes.default.bool,
  spaceDefaultEnabled: _propTypes.default.bool
};
MarketingModule2x1ImageLeft.defaultProps = {
  alignItems: 'top',
  spaceDefaultEnabled: false,
  imageFocalPointY: 0.5
};